import React from 'react';

import { Box, Typography, IconButton } from '@mui/material';

import { ReactComponent as ChevronDownIcon } from '../../../assets/icons/chevron_down_icon.svg';
import { Code } from '../../../types/Codes';

type Props = {
  code: Code;
};

const SavedCodeCellAdmin: React.FC<Props> = ({ code }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleRotate = () => setIsOpen(!isOpen);

  const rotate = isOpen ? 'rotate(180deg)' : 'rotate(0)';

  return (
    <Box className='table-view-cell-container'>
      <Box
        sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
        className='row'
      >
        <Typography
          sx={{ marginBottom: '8px' }}
          variant='subtitle'
          fontFamily={'SFProDisplay-Bold'}
        >
          {code.code}
        </Typography>
        <IconButton
          style={{ transform: rotate, transition: 'all 0.25s ease-in-out' }}
          onClick={() => handleRotate()}
          className={`${isOpen ? 'icon-selected' : 'icon'}`}
        >
          <ChevronDownIcon />
        </IconButton>
      </Box>
      <Typography
        sx={{ marginBottom: '8px' }}
        color='text.secondary'
        fontFamily={'SFProDisplay-Regular'}
      >
        {code.description}
      </Typography>
      {isOpen && (
        <Box sx={{ justifyContent: 'space-between' }} className='row'>
          {code.work_rvu && (
            <Box className='row'>
              <Typography
                sx={{ marginRight: '8px' }}
                fontFamily={'SFProDisplay-Bold'}
              >
                {code.work_rvu}
              </Typography>
              <Typography
                color='text.secondary'
                fontFamily={'SFProDisplay-Regular'}
              >
                Work RVU
              </Typography>
            </Box>
          )}
          {code.facility_total && (
            <Box className='row'>
              <Typography
                sx={{ marginRight: '8px' }}
                fontFamily={'SFProDisplay-Bold'}
              >
                {code.facility_total}
              </Typography>
              <Typography
                color='text.secondary'
                fontFamily={'SFProDisplay-Regular'}
              >
                Work RVU
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default SavedCodeCellAdmin;
